import { modes } from "../modes";
import { permissions } from "../permissions/permissions";
import { roles } from "../roles";

export const dashboardPermissionProfiles = {
    WASH_SLA: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER],
    },
    KPI_DASHBOARD_VIEW: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.DASHBOARD.KPI_DASHBOARD_VIEW],
    },
    KPI_DASHBOARD_VIEW_TAB_OVERVIEW: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.DASHBOARD.KPI_DASHBOARD_VIEW_TAB_OVERVIEW],
    },
    KPI_DASHBOARD_VIEW_TAB_INSPECTION: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.DASHBOARD.KPI_DASHBOARD_VIEW_TAB_INSPECTION],
    },
    DISPATCH_DASHBOARD_VIEW: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.DASHBOARD.DISPATCH_DASHBOARD_VIEW],
    },
    WASH_DASHBOARD_COMPLIANCE_GRAPH: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER],
        [modes.EDIT_PERMISSION]: [permissions.DASHBOARD.WASH_DASHBOARD_COMPLIANCE_GRAPH],
    },
    MECHANICAL_DASHBOARD_VIEW: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.DASHBOARD.MECHANICAL_DASHBOARD_VIEW],
    },
    MECHANICAL_DASHBOARD_VENDOR_SCOPED_VIEW: {
        [modes.EDIT]: [roles.VENDOR]
    },
    VIEW_REPORTS_SUB_MENU: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.ADMIN, roles.SUPERVISOR, roles.MECHANIC, roles.ACCOUNT_MANAGER]
    },
    ONE_ON_ONE: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.SUPERVISOR]
    },
    CREATE_INSPECTION: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.ADMIN, roles.SUPERVISOR,]
    },
    MECHANICAL_VIEW: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.ADMIN, roles.SUPERVISOR,],
        [modes.READONLY]: [roles.CLIENT, roles.MECHANIC, roles.VENDOR]
    },
    FLEET_DASHBOARD_VIEW: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.ADMIN, roles.SUPERVISOR, roles.CLIENT, roles.MECHANIC]
    },
    LOADS_DASHBOARD_VIEW: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.ADMIN, roles.SUPERVISOR, roles.CLIENT, roles.MECHANIC]
    },
    WASH_DASHBOARD_VIEW: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.ADMIN, roles.SUPERVISOR, roles.CLIENT, roles.MECHANIC]
    },
    LOT_MANAGEMENT_VIEW: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.ADMIN, roles.SUPERVISOR, roles.CLIENT, roles.MECHANIC]
    },
    WORKORDER_SLA: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER]
    },
    WORKORDER_CLIENT_FILTER: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.MECHANIC, roles.ACCOUNT_MANAGER, roles.VENDOR]
    },
    WORKORDER_PMF_WORKFLOW_STATUS_CARDS: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.ADMIN, roles.MECHANIC, roles.SUPERVISOR, roles.CLIENT]
    },
    CREATE_WORK_ORDER: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.MECHANIC],
        [modes.EDIT_PERMISSION]: [permissions.DASHBOARD.MECHANICAL_DASHBOARD_CREATE_WO, permissions.VEHICLE.ASSETS_DETAIL_PAGE_ADD_ACTIVITY_LOG],
    },
    MECHANICAL_DASHBOARD_IMPORT_ACTIVITIES: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.MECHANIC],
        [modes.EDIT_PERMISSION]: [permissions.DASHBOARD.MECHANICAL_DASHBOARD_IMPORT_ACTIVITIES],
    },
    CONFIGURE_TIME_IN_STATUS_THRESHOLD: {
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.DASHBOARD.CONFIGURE_TIME_IN_STATUS_THRESHOLD],
        [modes.READONLY_PERMISSION]: [permissions.DASHBOARD.MECHANICAL_DASHBOARD_VIEW],
    },
    SHOW_REPORT_SUB_MENU: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.SUPERVISOR]
    },
    SHOW_SLA_SUB_MENU: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER],
        [modes.EDIT_PERMISSION]: [
            permissions.REPORTS.STORAGE,
            permissions.REPORTS.VIEW_COST_CODES,
            permissions.INVOICES.READ_TRANSPORTATION_INVOICE,
            permissions.INVOICES.READ_STORAGE_INVOICE,
            permissions.INVOICES.READ_MECHANICAL_INVOICE,
            permissions.INVOICES.VIEW_VENDOR_INVOICE,
            permissions.INVOICES.VIEW_VENDOR_INVOICE_FILE,
            permissions.INVOICES.EDIT_VENDOR_INVOICE_FILE
        ]
    },
    SHOW_ADMIN_SUB_MENU: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.ADMIN, roles.SUPERVISOR, roles.CLIENT, roles.MECHANIC]
    },

    SHOW_BILLING_SUB_MENU: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER],
        [modes.EDIT_PERMISSION]: [
            //INVOICES_VIEW
            permissions.INVOICES.READ_TRANSPORTATION_INVOICE,
            permissions.INVOICES.READ_STORAGE_INVOICE,
            permissions.INVOICES.READ_MECHANICAL_INVOICE,
            //VIEW_VENDOR_INVOICE
            permissions.INVOICES.VIEW_VENDOR_INVOICE,
            permissions.INVOICES.EDIT_VENDOR_INVOICE,
            permissions.INVOICES.APPROVE_VENDOR_INVOICE,
            //MANAGE_PPRICING
            permissions.PRICING.MANAGE_PPRICING,
            //VIEW_COST_CODES_PAGE
            permissions.REPORTS.VIEW_COST_CODES,
            //VIEW_QUICKBOOKS_ACCOUNT_MAPPING
            permissions.INVOICES.VIEW_QUICKBOOKS_ACCOUNT_MAPPING,
            //TAX_VIEW
            permissions.TAX_RATE.FULL,
            permissions.TAX_RATE.VIEW,
            //VIEW_STORAGE_REPORTS,
            permissions.REPORTS.STORAGE,
        ],
    },
    SHOW_BILLING_INVOICES_SUB_MENU: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER],
        [modes.EDIT_PERMISSION]: [
            //INVOICES_VIEW
            permissions.INVOICES.READ_TRANSPORTATION_INVOICE,
            permissions.INVOICES.READ_STORAGE_INVOICE,
            permissions.INVOICES.READ_MECHANICAL_INVOICE,
            //VIEW_VENDOR_INVOICE
            permissions.INVOICES.VIEW_VENDOR_INVOICE,
            permissions.INVOICES.EDIT_VENDOR_INVOICE,
            permissions.INVOICES.APPROVE_VENDOR_INVOICE
        ],
    },
    SHOW_BILLING_FINANCIAL_REPORTS_SUB_MENU: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER],
        [modes.EDIT_PERMISSION]: [
            //VIEW_STORAGE_REPORTS,
            permissions.REPORTS.STORAGE,
            //INVOICES_VIEW
            permissions.INVOICES.READ_TRANSPORTATION_INVOICE,
            permissions.INVOICES.READ_STORAGE_INVOICE,
            permissions.INVOICES.READ_MECHANICAL_INVOICE,
        ],
    },
    SHOW_BILLING_CONFIG_REPORTS_SUB_MENU: {
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER],
        [modes.EDIT_PERMISSION]: [

            //MANAGE_PPRICING
            permissions.PRICING.MANAGE_PPRICING,
            //VIEW_COST_CODES_PAGE
            permissions.REPORTS.VIEW_COST_CODES,
            //VIEW_QUICKBOOKS_ACCOUNT_MAPPING
            permissions.INVOICES.VIEW_QUICKBOOKS_ACCOUNT_MAPPING,
            //TAX_VIEW
            permissions.TAX_RATE.FULL,
            permissions.TAX_RATE.VIEW
        ],
    },
    SHOW_LOTS_OPERATIONS_SUB_MENU: {
        [modes.EDIT]: [roles.OWNER, roles.ADMIN, roles.SUPERVISOR, roles.ACCOUNT_MANAGER],
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.SUPERVISOR],
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER],
        [modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.INSPECTION.INSPECTIONS_ACCESS],
        [modes.EDIT]: [roles.OWNER, roles.ACCOUNT_MANAGER, roles.SUPERVISOR]
    },
}